
const CrudCodeValues = require("./CrudCodeValues");
module.exports = {
    ASD: "ASD",
    FAM: "FAM",
    FU: "FU",
    HY: "HY",
    IP: "IP",
    PH: "PH",
    SY: "SY",
    ZONE: "ZONE"
};
